export const ADD_SECTION_REQUESTED = 'ADD_SECTION_REQUESTED';
export const ADD_SECTION_COMPLETED = 'ADD_SECTION_COMPLETED';
export const ADD_SECTION_ERROR = 'ADD_SECTION_ERROR';
export const REMOVE_SECTION_REQUESTED = 'REMOVE_SECTION_REQUESTED';
export const REMOVE_SECTION_COMPLETED = 'REMOVE_SECTION_COMPLETED';
export const REMOVE_SECTION_ERROR = 'REMOVE_SECTION_ERROR';
export const EDIT_SECTION_REQUESTED = 'EDIT_SECTION_REQUESTED';
export const EDIT_SECTION_COMPLETED = 'EDIT_SECTION_COMPLETED';
export const EDIT_SECTION_ERROR = 'EDIT_SECTION_ERROR';
export const ADD_ALL_SECTIONS_REQUESTED = 'ADD_ALL_SECTIONS_REQUESTED';
export const ADD_ALL_SECTIONS_COMPLETED = 'ADD_ALL_SECTIONS_COMPLETED';
export const ADD_ALL_SECTIONS_ERROR = 'ADD_ALL_SECTIONS_ERROR';
export const REMOVE_ALL_SECTIONS_REQUESTED = 'REMOVE_ALL_SECTIONS_REQUESTED';
export const REMOVE_ALL_SECTIONS_COMPLETED = 'REMOVE_ALL_SECTIONS_COMPLETED';
export const REMOVE_ALL_SECTIONS_ERROR = 'REMOVE_ALL_SECTIONS_ERROR';
export const REMOVE_ALL_UNSCOPED_SECTIONS_REQUESTED = 'REMOVE_ALL_UNSCOPED_SECTIONS_REQUESTED';
export const REMOVE_ALL_UNSCOPED_SECTIONS_COMPLETED = 'REMOVE_ALL_UNSCOPED_SECTIONS_COMPLETED';
export const REMOVE_ALL_UNSCOPED_SECTIONS_ERROR = 'REMOVE_ALL_UNSCOPED_SECTIONS_ERROR';
export const COPY_TO_CLIPBOARD_REQUESTED = 'COPY_TO_CLIPBOARD_REQUESTED';
export const COPY_TO_CLIPBOARD_COMPLETED = 'COPY_TO_CLIPBOARD_COMPLETED';
export const COPY_TO_CLIPBOARD_ERROR = 'COPY_TO_CLIPBOARD_ERROR';
